import { render, staticRenderFns } from "./recentList.vue?vue&type=template&id=e48cbc42"
import script from "./recentList.vue?vue&type=script&lang=js"
export * from "./recentList.vue?vue&type=script&lang=js"
import style0 from "./recentList.vue?vue&type=style&index=0&id=e48cbc42&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports